import React from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ComponentInfo, WizardItem, WizardMenu } from '@components';
import { rem } from '@helpers';
import { useNavigationStore } from '@store';

export const WizardMenuPlaceholder: React.FC = () => {
	const t = useTranslation();
	const { flow } = useNavigationStore();

	const wizardMenuItems = React.useMemo((): WizardItem[] => {
		if (flow === 'subscription') {
			return [
				{
					title: t('placeholders.wizardMenu.selectPlan'),
					route: 'subscriptionSelectPlan',
				},
				{
					title: t('placeholders.wizardMenu.selectAccount'),
					route: 'subscriptionSelectAccount',
				},
				{
					title: t('placeholders.wizardMenu.termsAndConditions'),
					children: [
						{
							title: t('placeholders.wizardMenu.termsAndConditionsSoftware'),
							route: 'subscriptionTermsAndConditionsSoftware',
						},
						{
							title: t('placeholders.wizardMenu.termsAndConditionsBank'),
							route: 'subscriptionTermsAndConditionsBank',
						},
					],
				},
				{
					title: t('placeholders.wizardMenu.resumeAndAuthorization'),
					route: 'subscriptionResumeAndAuthorization',
				},
				{
					title: t('placeholders.wizardMenu.conclusion'),
					route: 'subscriptionConclusion',
				},
			];
		} else {
			return [
				{
					title: t('placeholders.wizardMenu.selectSolution'),
					route: 'integratedSolutionSelectSolution',
				},
				{
					title: t('placeholders.wizardMenu.selectAccount'),
					route: 'integratedSolutionSelectAccount',
				},
				{
					title: t('placeholders.wizardMenu.termsAndConditions'),
					route: 'integratedSolutionTermsAndConditionsBank',
				},
				{
					title: t('placeholders.wizardMenu.Resume'),
					route: 'integratedSolutionResumeAndAuthorization',
				},
				{
					title: t('placeholders.wizardMenu.conclusion'),
					route: 'integratedSolutionConclusion',
				},
			];
		}
	}, [t, flow]);

	return (
		<ComponentInfo name="WizardMenuPlaceholder">
			<Box styles={{ margin: rem(36, 0, 0, 0) }}>
				<WizardMenu items={wizardMenuItems} />
			</Box>
		</ComponentInfo>
	);
};
